require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./configurations-custom-babel-config.json") })
        }
      }, "path---configurations-custom-babel-config");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---configurations-custom-babel-config!./.cache/json/configurations-custom-babel-config.json
// module id = 418
// module chunks = 231608221292675